import { HOME_FAQ } from "./site";
import { STATES, sortedAbbrs, stateFaqs } from "./states";

export const PRICING_FAQ = [
  ["Is there a contract or cancellation fee?", "No. Plans are month to month. If you leave, we provide your payroll history and file the returns for periods we processed."],
  ["Do you charge extra for each state?", "No. The monthly price is the same whether you pay people in one state or twenty. A one-time fee applies only if we register a new state tax account for you."],
  ["Who counts as a person paid?", "Any employee or contractor who receives a payment through ABSLpay in that month. People you do not pay that month are not billed."],
  ["Are payroll taxes included in the price?", "No provider includes the taxes themselves. We calculate, withhold, deposit and file them; the tax amounts are paid from your account on each payroll."],
];

export const buildAllFaqs = () => {
  const all = [
    ...HOME_FAQ.map(([q, a]) => ({ q, a, category: "General" })),
    ...PRICING_FAQ.map(([q, a]) => ({ q, a, category: "Pricing" })),
  ];
  sortedAbbrs.forEach((abbr) => {
    stateFaqs(abbr).forEach(([q, a]) => all.push({ q, a, category: STATES[abbr][0] }));
  });
  return all;
};
